<template>
  <div class="news-detail" v-if="content">
    <div class="title">{{ title }}</div>
    <div class="content" v-html="content"></div>
    <div class="image"><van-image :src="url"/></div>
  </div>
  <div class="news-detail" v-else>
    
  </div>
</template>

<script>
import API from '@/api/common';
export default {
  data() {
    return {
      id: this.$route.query.meetingId,
      type: this.$route.query.type,
      title: '',
      content: '',
      url: ''
    };
  },
  mounted() {
    this.getMeeting(this.id);
  },
  methods: {
    // 获取详情
    getMeeting(id) {
      API.getMeeting(id).then(res => {
        if (res.success) {
          const data = res.data
          if (this.type === 'beh') {
            this.title = data.behExamName
            this.content = data.behRemark
            this.url = data.behCodeUrl
          } else {
            this.title = data.preExamName
            this.content = data.preRemark
            this.url = data.preCodeUrl
          }
        }
      })
    }
  }
};
</script>

<style lang="less">
.content {
  margin: 0 10px;
}
.image {
  text-align: center;
}
p, span, h1, h2, h3, h4, h5, section {
  text-indent: 0px !important;
  font-size: initial;
}
p {
  font-family: 宋体;
  line-height: 3em;
  margin: 0 0;
}
span img, p img {
  width: 100% !important;
  height: auto !important;
}
.news-detail {
  height: 100%;
  background: #fff;
  padding-bottom: 40px;
  overflow: auto;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #f7f7f7;
  }
}
</style>
